<template>
  <div class="ly_mainInner">
    <div v-if="result === 'stageClear'" id="stageClear">
      <div class="bl_headingBlock">
        <!-- eslint-disable-next-line -->
        <p>{{ selectLevel.grade }}<ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby> ステージ {{ selectLevel.stage }} クリア！</p>
      </div>
      <div class="bl_resultBlock">
        <ul class="bl_stageList">
          <li v-for="n in 4" :key="n" class="bl_stageList_item" :class="isClearStageClass(n)">
            <transition name="StageClearStamp">
              <!-- eslint-disable-next-line -->
              <span v-if="is_clear_stage" :class="stageClearStamp(n)"></span>
            </transition>
            <!-- eslint-disable-next-line -->
            <span>{{ selectLevel.grade }}<ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby> ステージ {{ n }}</span>
          </li>
        </ul>
        <p><ruby>次<rp>(</rp><rt>つぎ</rt><rp>)</rp></ruby>のステージにチャレンジしよう</p>
      </div>
      <div class="bl_btnBlock">
        <a class="el_btn" href="#" @click="changeCurrentPage('selectStage')">つぎへ</a>
      </div>
    </div>
    <div v-if="result === 'gradeClear'" id="gradeClear">
      <div class="bl_headingBlock">
        <p>{{ selectLevel.grade }}<ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby> <ruby>合格<rp>(</rp><rt>ごうかく</rt><rp>)</rp></ruby>！</p>
      </div>
      <div class="bl_resultBlock">
        <!-- eslint-disable-next-line -->
        <div class="bl_stampBlock">
          <transition name="GradeClearStamp">
            <span class="el_gradeClearStamp"></span>
          </transition>
          {{ selectLevel.grade }}<ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby>
        </div>
        <!-- eslint-disable-next-line -->
        <p><ruby>次<rp>(</rp><rt>つぎ</rt><rp>)</rp></ruby>の<ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby>にチャレンジしよう</p>
      </div>
      <div class="bl_btnBlock">
        <a class="el_btn" href="#" @click="changeCurrentPage('selectStage')">つぎへ</a>
      </div>
    </div>
    <div v-if="result === 'complete'" id="complete">
      <div class="bl_headingBlock">
        <!-- eslint-disable-next-line -->
        <p>おだきゅうマスター<br class="spBlock"><ruby>認定<rp>(</rp><rt>にんてい</rt><rp>)</rp></ruby></p>
      </div>
      <div class="bl_resultBlock">
        <div class="bl_resultBlock_img">
          <img src="/kids/quiz/static/image/result_img_02.png" alt="">
        </div>
        <!-- eslint-disable-next-line -->
        <p>おめでとう！<ruby>全<rp>(</rp><rt>ぜん</rt><rp>)</rp></ruby>ステージクリアしたよ！<br>きみはおだきゅうマスターだ！</p>
      </div>
      <div class="bl_btnBlock">
        <!-- eslint-disable-next-line -->
        <a class="el_btn" href="#" @click="changeCurrentPage('selectGrade')">ステージ<ruby>選択<rp>(</rp><rt>せんたく</rt><rp>)</rp></ruby>へもどる</a>
        <a class="el_btn el_btn__gray" href="#" @click="changeCurrentPage('start')">トップへ</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'result',
  data() {
    return {
      result: '',
    };
  },
  computed: {
    ...mapState('selectLevel', [
      'selectLevel',
    ]),
    ...mapState('odakyuQuizClearData', [
      'clearData',
    ]),
  },
  created() {
    if (this.selectLevel.stage === 4) {
      if (this.selectLevel.grade === 1) {
        this.result = 'complete';
      } else {
        this.result = 'gradeClear';
      }
    } else {
      this.result = 'stageClear';
    }
  },
  methods: {
    changeCurrentPage(page) {
      this.setNextStage();
      this.$store.commit('currentPage/changeCurrentPage', page);
    },
    isClearStageClass(num) {
      if (this.clearData.grade !== 0) {
        if (this.clearData.grade < this.selectLevel.grade) {
          this.is_clear_stage = true;
          return {
            is_clear_stage: true,
          };
        } else if (
          this.clearData.grade === this.selectLevel.grade &&
          this.clearData.stage >= num
        ) {
          this.is_clear_stage = true;
          return {
            is_clear_stage: true,
          };
        }
      } else if (num === 1) {
        this.is_clear_stage = true;
        return {
          is_clear_stage: true,
        };
      }
      this.is_clear_stage = false;
      return {
        is_clear_stage: false,
      };
    },
    stageClearStamp(num) {
      if (num === this.selectLevel.stage) {
        return {
          el_stageClearStamp__anim: true,
        };
      }
      return {
        el_stageClearStamp: true,
      };
    },
    setNextStage() {
      // 次にチャレンジする級・ステージをカレント表示
      if (this.clearData.grade === 1 && this.clearData.stage === 4) {
        this.selectLevel.grade = this.clearData.grade;
        this.selectLevel.stage = this.clearData.stage;
      } else if (this.clearData.grade === 0) {
        this.selectLevel.grade = 5;
        this.selectLevel.stage = 1;
      } else if (this.clearData.stage !== 4) {
        this.selectLevel.grade = this.clearData.grade;
        this.selectLevel.stage = this.clearData.stage + 1;
      } else {
        this.selectLevel.grade = this.clearData.grade - 1;
        this.selectLevel.stage = 1;
      }
      this.selectLevel.questionCount = 1;
      this.$store.commit('selectLevel/setSelectLevel', this.selectLevel);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.GradeClearStamp-leave-active {
  display: none;
}

.el_gradeClearStamp {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('/kids/quiz/static/image/clear_img_01.png') center no-repeat;
  background-size: 95% auto;
  opacity: 1;
  z-index: 1;
  animation: StampBounce01 1s ease;
}

.StageClearStamp-leave-active {
  display: none;
}

.el_stageClearStamp {
  position: absolute;
  top: -10px;
  left: 0;
  background: url('/kids/quiz/static/image/clear_img_02.png') center left 17px no-repeat;
  background-size: auto 70%;
  width: 100%;
  height: 100%;
  opacity: 1;
  z-index: 1;
}

.el_stageClearStamp__anim {
  position: absolute;
  top: -10px;
  left: 0;
  background: url('/kids/quiz/static/image/clear_img_02.png') center left 17px no-repeat;
  background-size: auto 70%;
  width: 100%;
  height: 100%;
  opacity: 1;
  z-index: 1;
  animation: StampBounce02 0.5s ease;
}

@keyframes StampBounce01 {
  0% { opacity: 0; transform: scale(2.0, 2.0); }
  80% { opacity: 1; transform: scale(0.95, 0.95); }
  95% { transform: scale(1.1, 1.1); }
  100% { transform: scale(1, 1); }
}

@keyframes StampBounce02 {
  0% { opacity: 0; transform: scale(2.0, 2.0); }
  60% { opacity: 1; transform: scale(0.95, 0.95); }
  65% { transform: scale(1.05, 1.05); }
  70% { transform: scale(1, 1); }
  100% { transform: scale(1, 1); }
}

.ly_mainInner{
  text-align: center;

  .bl_headingBlock{
    font-size: 44px;
    font-weight: bold;
    margin-bottom: 35px;
  }
  .bl_resultBlock{
    margin: 0 auto;
  }
  .bl_btnBlock{
    margin: 25px auto 0;
    display: flex;
    justify-content: center;

    .el_btn{
      max-width: 324.7px;
    }
  }

  #stageClear{
    width: 100%;
    font-size: 24px;

    .bl_resultBlock{
      .bl_stageList{
        max-width: 370px;
        margin: 0 auto 25px;

        .bl_stageList_item{
          padding: 20px 0;
          line-height: 46px;
          font-weight: bold;
          position: relative;

          &:last-of-type{
            margin-bottom: 0;
          }
        }
      }
    }
  }

  #gradeClear{
    width: 100%;

    .bl_headingBlock{
      color: #d0021b;
    }

    .bl_resultBlock{
      .bl_stampBlock{
        position: relative;
        width: 250px;
        height: 250px;
        margin: 0 auto 30px;
        background-color: #fff;
        border: 3px solid #000;
        border-radius: 50%;
        text-align: center;
        font-size: 32px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;

        &::after{
          content: "";
          position: absolute;
          top: -160px;
          right: -230px;
          width: 100%;
          height: 100%;
          background: url('/kids/quiz/static/image/result_img_01.png') center no-repeat;
          background-size: contain;
          pointer-events: none;
          z-index: 2;
        }
      }
    }
  }

  #complete{
    width: 100%;

    .bl_headingBlock{
      color: #d0021b;
    }

    .bl_resultBlock{
      margin-bottom: 3.8px;
      text-align: center;

      .bl_resultBlock_img{
        max-width: 619px;
        margin: 0 auto 20px;
      }
    }

    .bl_btnBlock{
      .el_btn{
        margin-right: 10px;

        &:last-of-type{
          margin-right: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 768px){

  .el_stageClearStamp {
    top: -5px;
    left: 33px;
  }

  .el_stageClearStamp__anim {
    top: -5px;
    left: 33px;
  }

  @keyframes StampBounce02 {
    0% {
      opacity: 0;
      top: -150px;
      left: -100px;
      width: 300%;
      height: 300%;
    }
    100% {
      opacity: 1;
      top: -5px;
      left: 33px;
      width: 100%;
      height: 100%;
    }
  }

  .ly_mainInner{
    font-size: 18px;

    .bl_headingBlock{
      font-size: 34px;
      margin-bottom: 27px;
    }

    .bl_btnBlock{
      margin-top: 10px;
    }

    #stageClear{
      font-size: 18px;

      .bl_headingBlock{
        font-size: 26px;
      }

      .bl_resultBlock{
        .bl_stageList{
          margin-bottom: 35px;

          .bl_stageList_item{
            padding: 10px 0;

            &.is_clear_stage{
              > span{
                &::before{
                  width: 69px;
                  height: 39px;
                  top: -15px;
                  right: -55px;
                }
              }
            }
          }
        }
      }
    }

    #gradeClear{
      .bl_headingBlock{
        margin-bottom: 44px;
        font-size: 34px;
      }

      .bl_resultBlock{
        .bl_stampBlock{
          width: 180px;
          height: 180px;
          font-size: 34px;

          &::after{
            width: 160%;
            height: 160%;
            top: -170px;
            right: -240px;
          }
        }
      }
    }

    #complete{
      .bl_headingBlock{
        margin-bottom: 0;
      }

      .bl_resultBlock{
        .bl_resultBlock_img{
          margin-bottom: 30px;
        }
      }

      .bl_btnBlock{
        flex-direction: column;

        .el_btn{
          margin-right: 0;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Result.vue